import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import type { DashboardInfoTypeEnum } from "@/enums"
import { DateHelper } from "@/helpers"
import type {
  DashboardInfoType,
  DashboardSearchParamsType,
} from "@/types/dashboard"
import { StringHelper } from "@/utils"
export const dashboardInfo = async (
  params: DashboardSearchParamsType<DashboardInfoTypeEnum>
) => {
  const queryString =
    StringHelper.objectToQueryString(params)
  const url = `${ENDPOINTS.DASHBOARD}?${queryString}`
  const { data } = await api.get<DashboardInfoType>(url)
  return data
}
const useDashboard = ({
  startDate,
  endDate,
  dashboardType,
  enabled = true,
}: DashboardSearchParamsType<DashboardInfoTypeEnum> & {
  enabled?: boolean
}) => {
  const { selectedWhiteLabel, authData } = useAuth()
  const isAuthenticated = !!authData?.accessToken
  const { from, to } = DateHelper.getFromAndToDateMonth({
    from: startDate,
    to: endDate,
  })
  const queryStringParams: DashboardSearchParamsType<DashboardInfoTypeEnum> =
    {
      startDate: from,
      endDate: to,
      dashboardType,
      whitelabel_ids: selectedWhiteLabel?.uuid,
    }
  return useQuery({
    queryKey: [ENDPOINTS.DASHBOARD, queryStringParams],
    queryFn: async () => {
      const data = await dashboardInfo(queryStringParams)
      return data
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: enabled && isAuthenticated,
  })
}
export default useDashboard
